export const nutritionUnderstandings = [
  'Patient is clearly aware of foods that affect their health status',
  'Patient is aware of most foods that raise measurement levels, but unaware of how to balance meals.',
  'Patient is unaware of most foods that raise measurement levels.'
];
